import { Component, Input } from '@builder.io/sdk';

import { moleculeHeadingFields } from 'molecules/Heading/config';
import sectionFields from 'molecules/Section/config';

const iFrameFields = [
  ...moleculeHeadingFields,
  {
    name: 'iframe',
    type: 'reference',
    model: 'i-frame',
    helperText:
      'Select the iFrame entry to embed. The referenced model should include a title (optional) and the src URL to load.',
  },
  {
    name: 'aspectRatio',
    type: 'string',
    enum: [
      { label: 'Default (full viewport height)', value: '' },
      { label: 'Navattic (16:9 + 41px footer)', value: 'navattic' },
      { label: '16:9', value: '16:9' },
      { label: '4:3', value: '4:3' },
    ],
    helperText:
      'Optional. Wraps the iframe in a responsive aspect-ratio container. Leave as Default to keep full viewport height.',
  },
  {
    name: 'hideOnMobile',
    type: 'boolean',
    defaultValue: false,
    helperText:
      'When true, the whole iframe section is hidden on screens under 640px. Useful when the embed (e.g. a product demo) is not usable on mobile.',
  },
  ...sectionFields,
] as const satisfies DeepReadonly<Input[]>;

const iFrameConfig = {
  name: 'iframe',
  inputs: iFrameFields,
} satisfies Component;

export type IFrameConfigProps = Omit<GenerateBuilder<typeof iFrameFields>, 'iframe'> & {
  iframe: BuilderReference<{ title?: string; src?: string }>;
};

export default iFrameConfig;
